<div class="filterInput" (click)="toggleFilter($event)" *ngIf="filterObject">
  <i *ngIf="!filterObject.active" class="fa fa-search toggleInput pointer"></i>

  <span *ngIf="filterObject.active">
    <mat-form-field appearance="outline">
      <span *ngIf="!isDate" class="d-flex justify-content-between">
        <input
          matInput
          (click)="handleFilter($event)"
          (input)="onFilterValueChange($event.target)"
          [value]="filterObject.value"
          [type]="filterObject.numeric ? 'number' : 'text'"
          [cdkTrapFocus]="filterClicked"
          [cdkTrapFocusAutoCapture]="filterClicked"
          (blur)="toggleEmptyFilter($event)"
          onwheel="this.blur()"
        />
      </span>
      <span *ngIf="isDate" class="d-flex justify-content-between">
        <input
          #MatInput
          matInput
          [matDatepicker]="filterDatePicker"
          (click)="handleFilter($event)"
          (dateChange)="onFilterValueChange($event.target)"
          [value]="filterObject.displayValue"
          [type]="filterObject.numeric ? 'number' : 'text'"
          [cdkTrapFocus]="filterClicked"
          [cdkTrapFocusAutoCapture]="filterClicked"
          (blur)="toggleEmptyFilter($event)"
          onwheel="this.blur()"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="filterDatePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker
          #filterDatePicker
          (closed)="toggleEmptyFilter()"
        ></mat-datepicker>
      </span>
    </mat-form-field>
  </span>
</div>
